export const presellerColumnsMetaData = {
  columns: [
    {
      headerName: "Order No. & Date",
      mappedValue: "orderNumber, creationTime",
      width: 100,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name  ", bottom: "& Code" },
      mappedValue: "outletName, outletCode",
      width: 100,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "SalesRep Name & ID",
      headerParts: { top: "SalesRep Name ", bottom: "& ID" },
      mappedValue: "salesRepName, salesRepId",
      width: 100,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Route ID & Name",
      headerParts: { top: "Route ID ", bottom: "& Name" },
      mappedValue: "salesRoute, salesRouteName",
      width: 60,
      headerAlign: "left",
      align: "left",
      type: "order",
      truncateText: true,
    },
    {
      headerName: "No. of SKUs",
      headerParts: { top: "No. of ", bottom: "SKUs" },
      mappedValue: "skuCount",
      width: 40,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Qty",
      mappedValue:
        "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity",
      width: 70,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Amount",
      mappedValue: "netAmount",
      width: 70,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "GST Amt.",
      mappedValue: "gstAmount",
      width: 60,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
  ],
  Actions: [],
};

export const presellerReviewColumnsMetaData = {
  columns: [
    {
      headerName: "Order No. & Date",
      headerParts: { top: "Order No.  ", bottom: "& Date" },
      mappedValue: "orderNumber, creationTime",
      width: 120,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Invoice No.",
      mappedValue: "invoiceDisplayNumber",
      width: 100,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "Outlet Name & Code",
      headerParts: { top: "Outlet Name  ", bottom: "& Code" },
      mappedValue: "outletName, outletCode",
      width: 90,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
    {
      headerName: "No. of SKUs",
      headerParts: { top: "No. of ", bottom: "SKUs" },
      mappedValue: "skuCount",
      width: 50,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Qty",
      mappedValue:
        "totalCaseQuantity, totalPieceQuantity, totalOtherUnitQuantity",
      width: 90,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Amount",
      mappedValue: "netAmount",
      width: 80,
      headerAlign: "left",
      align: "left",
      truncateText: true,
    },
  ],
  Actions: [],
};

export const initalFiltersConfig = [
  {
    key: "salesRepOrRoute",
    label: "Sales Rep",
    order: 1,
    isNecessary: true,
    multiSelect: true,
  },
  {
    key: "salesman",
    label: "SalesMan",
    order: 2,
    isNecessary: true,
    multiSelect: false,
  },
  {
    key: "vehicle",
    label: "Vehicle",
    order: 3,
    isNecessary: true,
    multiSelect: false,
  },
  {
    key: "deliveryDate",
    label: "Delivery Date",
    order: 4,
    isNecessary: true,
    multiSelect: false,
  },
];

export const errorCodeToMessageMap = {
  "BulkInvoiceStatusUpdateStep-ERROR5007":
    "Loadout creation not allowed—invoice is linked to a invalid sales status.",
  "BulkOrderStatusUpdateStep-ERROR5007":
    "Loadout creation not allowed—invoice is linked to a invalid order status.",
  "BulkInvoiceStatusUpdateStep-ERROR5009":
    "Invoice Status not updated. Please try again later",
  "BulkOrderStatusUpdateStep-ERROR5009":
    "Order Status not updated. Please try again later",
  "BulkInvoiceStatusUpdateStep-ERROR2001":
    "No orders found for the provided order numbers",
  "BulkOrderStatusUpdateStep-ERROR2001":
    "No orders found for the provided order numbers",
  "BulkInvoiceStatusUpdateStep-ERROR2023":
    "Mismatch in Invoice status update. Please try again later",
  "BulkOrderStatusUpdateStep-ERROR2024":
    "Mismatch in Order status update. Please try again later",
  "BulkInvoiceStatusUpdateStep-ERROR2106":
    "No invoices found for the provided invoice numbers",

  "BulkStockUpdateStep-ERROR5006":
    "Something went wrong while Loadout creation",
  "BulkStockUpdateStep-ERROR5007":
    "Missing Item Details for Loadout Creation. Please try again later",
  "BulkStockUpdateStep-ERROR4002":
    "Error in stock movement. Please try again later",
  "BulkStockUpdateStep-ERROR5000":
    "Something went wrong while Stock reversal. Please try again later",

  "LoadoutStep-ERROR4001": "Something went wrong while Loadout creation",
  "LoadoutStep-ERROR5009": "Something went wrong while Loadout creation",
  "LoadoutStep-ERROR5000": "Something went wrong while Loadout creation",

  "UpdateInvoiceStep-ERROR5012": "Invoice not updated. Please try again later",
  "UpdateInvoiceStep-ERROR5000": "Invoice not updated. Please try again later",
  "UpdateInvoiceStep-ERROR6002": "Credit status not found for outlet. Please contact support.",

  "CreateSalesReturnStep-ERROR5000":
    "Error while creating Sales return. Please try again later",

  "UpdateVehicleInfoStep-ERROR5416":
    "There was an error while updating the vehicle status. Please try again later",
};
